import fetcher from '@api/fetchers';

export const fetchS3SignInUrl = (fileName, type = 0, uid = '', contentType) =>
  fetcher(
    `v1/s3_url/?objectName=${encodeURIComponent(fileName)}&type=${type}${
      uid ? `&uid=${uid}` : ''
    }${contentType ? `&contentType=${contentType}` : ''}`,
    { useCamelCase: false }
  );

export const submitIssue = (data) =>
  fetcher('v1/user/me/report_bug/', {
    requestType: 'POST',
    useCamelCase: false,
    body: {
      data
    }
  });
